interface Invariant {
    (condition: boolean, message: string, ErrorConstructor?: typeof InvariantError): asserts condition;
    (condition: boolean, message: Error, ErrorConstructor?: void): asserts condition;
}

export const invariant: Invariant = (condition, message, ErrorConstructor = InvariantError) => {
    if (!condition) {
        if (message instanceof Error) throw message;
        else throw new ErrorConstructor(message);
    }
};

export const unreachable = (message: string): never => {
    throw new InvariantError(message);
};

class InvariantError extends Error {
    readonly name = 'InvariantError';
}
